import { type OperationContext, type OperationResult, useMutation } from "urql"

import type {
  EquivalencyGroupMutationCreateArgs,
  EquivalencyGroupMutationDeleteArgs,
  EquivalencyGroupMutationUpdateArgs,
  Mutation,
} from "@/graphql/codegen/graphql"
import {
  CreateEquivalencyGroupDocument,
  DeleteEquivalencyGroupDocument,
  UpdateEquivalencyGroupDocument,
} from "@/graphql/codegen/graphql"

interface UseEquivalencyGroupReturn {
  createEquivalencyGroup: (
    variables: EquivalencyGroupMutationCreateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "equivalencyGroup">, EquivalencyGroupMutationCreateArgs>>
  updateEquivalencyGroup: (
    variables: EquivalencyGroupMutationUpdateArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "equivalencyGroup">, EquivalencyGroupMutationUpdateArgs>>
  deleteEquivalencyGroup: (
    variables: EquivalencyGroupMutationDeleteArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "equivalencyGroup">, EquivalencyGroupMutationDeleteArgs>>
}

export const useEquivalencyGroup = (): UseEquivalencyGroupReturn => {
  const [, createEquivalencyGroup] = useMutation<
    Pick<Mutation, "equivalencyGroup">,
    EquivalencyGroupMutationCreateArgs
  >(CreateEquivalencyGroupDocument)

  const [, updateEquivalencyGroup] = useMutation<
    Pick<Mutation, "equivalencyGroup">,
    EquivalencyGroupMutationUpdateArgs
  >(UpdateEquivalencyGroupDocument)

  const [, deleteEquivalencyGroup] = useMutation<
    Pick<Mutation, "equivalencyGroup">,
    EquivalencyGroupMutationDeleteArgs
  >(DeleteEquivalencyGroupDocument)

  return {
    createEquivalencyGroup,
    updateEquivalencyGroup,
    deleteEquivalencyGroup,
  }
}
